import _ from 'lodash';
import { createSelector } from 'reselect';

const getRoles = state => state.role.all;

const getLoading = state => state.rolesList.loading;

const rolesLoading = createSelector(
  getLoading,
  loading => loading
);

const getRolesById = createSelector(
  getRoles,
  roles => _.keyBy(roles, 'id')
);

const getOtherRole = createSelector(
  getRoles,
  roles => _.find(roles, role => role.other)
);

const getOtherRoleId = createSelector(
  getOtherRole,
  role => role.id
);

export { getRoles, getRolesById, getOtherRole, getOtherRoleId, rolesLoading };



// WEBPACK FOOTER //
// ./src/selectors/roles.js